/**
 * Formats a Date as YYYY-MM-DD using its LOCAL calendar date parts.
 *
 * Deliberately not `d.toISOString().slice(0, 10)`: that reads the UTC date,
 * which differs from the browser's local "today" for part of every day in
 * any timezone other than UTC - e.g. an admin in Tokyo (UTC+9) opening a page
 * at 2am local time would get "yesterday" as the default date.
 */
export function toLocalDateString(d: Date): string {
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}
